<template>
    <div>
        <h3 class="Modal__title">Mon compte</h3>
        <button class="Btn m-t-15 Btn--block Btn--primary" @click="$emit('setView', 'profile')">Modifier mes
            informations
        </button>
        <button class="Btn m-t-15 Btn--block Btn--primary" @click="$emit('setView', 'email')">Modifier mon
            adresse-email
        </button>
        <button class="Btn m-t-15 Btn--block Btn--primary" @click="$emit('setView', 'password')">Modifier mon mot de
            passe
        </button>
        <a href="/logout" class="Btn m-t-50 Btn--block Btn--stroked">Déconnexion</a>
        <button @click="deleteAccount" class="Btn m-t-15 Btn--block Btn--danger Btn--stroked">Supprimer mon compte
        </button>
    </div>
</template>

<script>
    import ModalBus from "../../../eventBus";
    import Api from "../../../services/Api";

    export default {
        methods: {
            deleteAccount: function () {
                ModalBus.alert('Êtes-vous sûr ?', 'Voulez-vous vraiment supprimer votre compte ?', {
                    icon: 'fas fa-question',
                    closeButton: false,
                    buttons: [
                        {
                            label: 'Non, annuler',
                            class: 'Btn Btn--stroked',
                            onClick: function () {
                                ModalBus.$emit('close');
                            }
                        },
                        {
                            label: 'Oui, supprimer',
                            class: 'Btn',
                            onClick: async function () {
                                try {
                                    await Api.delete('/account');
                                    window.location.href = '/logout';
                                } catch (err) {
                                    ModalBus.processingError();
                                }
                            }
                        }
                    ]
                })
            }
        }
    }
</script>
